module.exports = __webpack_public_path__ + "static/kandddinsky-6aad050ddc2b184ba9b94d880753b6da.png";